<agr-page-detail
  pageTitle="{{ 'app.contactperson.relations.location_detail_page_title' | translate }} {{
    contactpersonName$ | async
  }}"
  (backAction)="back()"
>
  @if ((routeUrl$ | async)?.endsWith('/relations/add')) {
    <div class="spacing--padding-all" data-test="relation-location__detail">
      <div class="text--h6">
        {{ 'app.contactperson.relations.title_search_customer' | translate }}
      </div>
      <div class="search-customer__container">
        <app-search-field
          class="search-customer"
          [placeholderText]="'app.customer.search.placeholder' | translate"
          [autoCompleteOptions]="customers$"
          (optionSelected)="selectCustomer($event)"
          [isLoading$]="isLoading$"
          (searchValueChanged)="searchValueChanged($event)"
        ></app-search-field>
      </div>
    </div>
  }

  <!-- overview van locations van de geselecteerde customer -->
  @if (customerId) {
    <div class="spacing--padding-all">
      <div class="text--h6">
        {{ 'app.contactperson.relations.title_select_location' | translate }}
      </div>
      <ng-container [agrBlockSpinner]="(locations$ | async) === undefined">
        @if ((locations$ | async)?.length === 0) {
          <div class="wrapper--spacing-horizontal">
            <agr-notification-empty
              emptyTitle="{{ 'app.no_results_title' | translate }}"
              emptyDescription="{{ 'app.no_results_description' | translate }}"
              [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
            ></agr-notification-empty>
          </div>
        } @else {
          <mat-slide-toggle
            labelPosition="after"
            color="primary"
            [checked]="locationWithNoRelation$ | async"
            (change)="toggleRelationForLocation($event)"
            data-test="customer-relations__toggleAll"
          >
            {{ 'app.contactperson.all_locations_relation_label' | translate }}
          </mat-slide-toggle>
          <mat-nav-list>
            @for (location of locations$ | async; track location) {
              <a
                href="#"
                mat-list-item
                data-test="customer-overview__item"
                class="listItem"
                (click)="clickRelationForLocation($event, location)"
              >
                <mat-icon matListItemAvatar class="list-avatar">perm_identity</mat-icon>
                <div matListItemTitle class="text--h3">{{ location.name }}</div>
                <div matListItemLine class="text--gray">
                  {{ location.street }} {{ location.houseNumber }}
                  {{ location.houseNumberAddition }} {{ location.postalCode }} {{ location.city }},
                  {{ 'app.countries.' + location.country | translate }}
                </div>
                <mat-slide-toggle
                  matListItemMeta
                  labelPosition="after"
                  [attr.data-test]="'customer__relations--' + location.id"
                  color="primary"
                  [checked]="location.contactPersonHasRelation"
                  >{{ 'app.contactperson.has_relation_label' | translate }}</mat-slide-toggle
                >
              </a>
            }
            <mat-divider></mat-divider>
          </mat-nav-list>
        }
      </ng-container>
    </div>
  }
</agr-page-detail>
